<template>
  <Modal
    name="CUSTOMER_LINK_VENDORS_MODAL"
    :title="$t('customer.label.linkVendors')"
    persistent
  >
    <template v-slot:body>
      <v-form ref="vendorsForm" v-model="valid">
        <v-autocomplete
          :label="$t('customer.label.vendors')"
          v-model="selectedVendors"
          :items="vendors"
          item-text="name"
          item-value="id"
          :rules="[rules.required]"
          outlined
          multiple
          hide-selected
          small-chips
          hide-details="auto"
          clearable
        />
        
        <div class="mt-5 text-right">
          <v-btn
          @click="linkVendorsToCustomer()"
          :loading="isLoading"
          color="primary"
          elevation="0"
          :disabled="!valid"
          >
          {{ $t('customer.label.save') }}
        </v-btn>
      </div>
    </v-form>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal'
import { mapGetters, mapActions } from 'vuex'
import { required } from '@/util/errorHandling'

export default {
  name: 'ModalLinkVendors',

  props: {
    customer: {
      type: Object,
    },
  },

  components: {
    Modal
  },

  data() {
    return {
      valid: false,
      rules: {
        required,
      },
      selectedVendors: []
    }
  },

  watch: {
    customer(newCustomer) {
      this.selectedVendors = newCustomer.vendors ? newCustomer.vendors.map(vendor => vendor.id) : []
      this.findAllVendors()
    },
  },

  computed: {
    ...mapGetters(['isLoading', 'vendors']),
  },

  methods: {
    ...mapActions(['findAllVendors', 'linkVendors']),

    linkVendorsToCustomer() {
      const body = {
        real_estate_id: this.customer.customerId,
        vendors_ids: this.selectedVendors
      }

      this.linkVendors(body)
    }
  },
}
</script>
